// import { Api } from '@/service';

//restful api
import { mailLog as log } from '@/service/api/log'

export default {
  data : () => {
    return {
      model : {},
      click: false,
      show : false,
    }
  },
  methods: {
    list() { this.$router.push({ name: 'log_mail'}); },
    async get( id = this.$route.params) {
      console.log('log.mail.detail.vue', 'load item', id);
      try {
        // let rs = await Api.Manager_Call('log.mail', 'detail', { id : Number(id.id) })
        let rs = await log.detailMail({ id : Number(id.id) })
        this.model = rs.body;


        let content = [];
        let json_content = JSON.parse(this.model.contents)
        let k_c = Object.keys(json_content);
        for (let i = 0; i < k_c.length; i++) {
          if(k_c[i] == 'id') { continue; }
          content.push(`${k_c[i]} : ${json_content[k_c[i]]}`);
        }
        this.model.content = content.join("\n")
        this.model.email_cc = this.model.email_cc && this.model.email_cc.indexOf(",") > -1 ?  this.model.email_cc.split(",").join("\n") : this.model.email_cc
        this.model.email_to = this.model.email_to && this.model.email_to.indexOf(",") > -1 ?  this.model.email_to.split(",").join("\n") : this.model.email_to
        this.model.email_bcc = this.model.email_bcc && this.model.email_bcc.indexOf(",") > -1 ?  this.model.email_bcc.split(",").join("\n") : this.model.email_to

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    change_name(){
      if(this.click){
        this.click = false;
        this.show = false;

        let i = $('i.fa')

        if(i.hasClass('fa-sort-asc')){
          i.removeClass('fa-sort-asc') && i.addClass('fa-sort-desc')
        }
      }else{
        this.click = true;
        this.show = true;

        let i = $('i.fa')

        if(i.hasClass('fa-sort-desc')){
          i.removeClass('fa-sort-desc') && i.addClass('fa-sort-asc')
        }
      }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('log.mail.detail.vue', 'created'); },
  destroyed() { console.log('log.mail.detail.vue', 'destroyed'); },
  mounted() {
    console.log('log.mail.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}